// extracted by mini-css-extract-plugin
export var aggregationCell = "_53-t";
export var aggregationRow = "_53-s";
export var borderlessSpinnerContainer = "_53-3";
export var cardLayout = "_53-6";
export var cardLayoutNoFooter = "_53-a";
export var cardLayoutPageControl = "_53-9";
export var cardLayoutWithFooter = "_53-8";
export var closeIcon = "_53-l";
export var columnHeaderSurface = "_53-d";
export var columnHeaderSurfaceDragOverlay = "_53-11";
export var columnHeaderSurfaceResizing = "_53-y";
export var contextMenuAnchor = "_53-1";
export var draggableColumnHeader = "_53-z";
export var draggableColumnHeaderOverlay = "_53-10";
export var expandIcon = "_53-m";
export var expanded = "_53-n";
export var filterBackIcon = "_53-g";
export var filterButtonAnchor = "_53-f";
export var filterDropdown = "_53-o";
export var filterDropdownDivider = "_53-j";
export var filterDropdownHeader = "_53-r";
export var filterDropdownItem = "_53-q";
export var filterDropdownModal = "_53-p _53-o";
export var filterItem = "_53-e";
export var normalCellWithAdjustableBorder = "_53-k";
export var pinButtonContainer = "_53-u";
export var pinIcon = "_53-v";
export var pinIconActive = "_53-w";
export var spinner = "_53-0";
export var spinnerContainer = "_53-2";
export var subFilterArrowIcon = "_53-h";
export var tableContainer = "_53-4";
export var tableContentDraggingColumns = "_53-c";
export var tableContentInner = "_53-7";
export var tableContentInnerFill = "_53-b";
export var tableContentWrapper = "_53-5";
export var toolbarEnd = "_53-i";
export var viewButtonContainer = "_53-x";